import React, { useState } from "react";
import Minus from "images/Minus.svg";
import Plus from "images/Plus.svg";
import NcImage from "images/faq.png";

interface SectionProps {
  title: string;
  children: React.ReactNode;
  isOpen: boolean;
  onToggle: () => void;
}

const Section: React.FC<SectionProps> = ({
  title,
  children,
  isOpen,
  onToggle,
}) => {
  return (
    <div className=" my-4 rounded-xl">
      <button
        onClick={onToggle}
        className="flex justify-between w-full space-x-4  py-6 text-left items-center"
      >
        <span className="text-lg font-semibold leading-7 text-left text-[#121212]">
          {title}
        </span>
        <span>
          {isOpen ? (
           <svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.5515 6.48438L7.61398 0.898438C7.40565 0.716146 7.1843 0.625 6.94992 0.625C6.71555 0.625 6.50721 0.716146 6.32492 0.898438L0.387422 6.48438C-0.00320329 6.92708 -0.0162241 7.36979 0.348359 7.8125C0.765026 8.20312 1.20773 8.21615 1.67648 7.85156L6.94992 2.85156L12.2624 7.85156C12.7051 8.21615 13.1348 8.21615 13.5515 7.85156C13.9161 7.38281 13.9161 6.92708 13.5515 6.48438Z" fill="#F4A84A"/>
</svg>

          ) : (
            <svg
              width="14"
              height="8"
              viewBox="0 0 14 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.5515 1.8457L7.61398 7.43164C7.40565 7.61393 7.1843 7.70508 6.94992 7.70508C6.71555 7.70508 6.50721 7.61393 6.32492 7.43164L0.387422 1.8457C-0.00320329 1.40299 -0.0162241 0.960287 0.348359 0.517578C0.765026 0.126953 1.20773 0.113932 1.67648 0.478516L6.94992 5.47852L12.2624 0.478516C12.7051 0.113932 13.1348 0.113932 13.5515 0.478516C13.9161 0.947266 13.9161 1.40299 13.5515 1.8457Z"
                fill="#1A685B"
              />
            </svg>
          )}
        </span>
      </button>
      {isOpen && <div className="px-4 py-2">{children}</div>}
    </div>
  );
};

const FAQ: React.FC = () => {
  const [openSectionIndex, setOpenSectionIndex] = useState<number | null>(null);

  const handleToggle = (index: number) => {
    setOpenSectionIndex(openSectionIndex === index ? null : index);
  };
  return (
    <>
      <div className="justify-center mb-8 text-center"></div>
      <div className="grid grid-cols-1 lg:grid-cols-2 items-start gap-14">
        <div className="flex flex-col space-y-10 justify-center">
          <img className="" src={NcImage} alt="" />
        </div>

        <div className="">
          <h2 className="text-4xl font-semibold">Have Any Questions For Us?</h2>
          <Section
            title="What is the minimum age requirement for renting?"
            isOpen={openSectionIndex === 1}
            onToggle={() => handleToggle(1)}
          >
            <span className="text-base font-normal leading-6 text-left text-[#121212B2]">
              You must be 21 or older with a valid drivers license to rent.
            </span>
          </Section>

          <Section
            title="Is there a security deposit needed for rentals?"
            isOpen={openSectionIndex === 3}
            onToggle={() => handleToggle(3)}
          >
            <span className="text-base font-normal leading-6 text-left text-[#121212B2]">
              There’s a security deposit of $250, the security deposit is for
              gas, smoking and cleaning. If any of these things are violated,
              you’ll be charged.
            </span>
          </Section>
          <Section
            title=" Is there a minimum rental duration?"
            isOpen={openSectionIndex === 4}
            onToggle={() => handleToggle(4)}
          >
            <span className="text-base font-normal leading-6 text-left text-[#121212B2]">
              Yes, our minimum rental period is 24 hours.
            </span>
          </Section>
          <Section
            title="Do I need my own auto insurance to rent?"
            isOpen={openSectionIndex === 5}
            onToggle={() => handleToggle(5)}
          >
            <span className="text-base font-normal leading-6 text-left text-[#121212B2]">
              You do not need your own insurance. It is a requirement to
              purchase insurance.
            </span>
          </Section>
        </div>
      </div>
    </>
  );
};

export default FAQ;
